'use client';

import React, { useEffect, useRef } from 'react';

import AppImage from '@/components/ui/AppImage';

export default function HeroSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ height: '100svh', minHeight: '640px' }}
      id="hero"
    >
      {/* Full-screen background image */}
      <div className="absolute inset-0 kb-1">
        <AppImage
          src="/assets/images/39EA19B6-46A1-4A0A-B47B-85AF3EBE1AA6-1781229078063.png"
          alt="ALLYWRK media production team capturing cinematic footage on location"
          fill
          className="object-cover"
          priority
        />
      </div>
      {/* Dark overlay */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background:
            'linear-gradient(170deg, rgba(10,10,10,0.5) 0%, rgba(10,10,10,0.75) 50%, rgba(10,10,10,0.97) 100%)',
        }}
      />
      {/* Noise */}
      <div className="noise-overlay z-20" />
      {/* Pulse glow accent */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 pulse-glow"
        style={{
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(170,255,0,0.06) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      {/* Hero content */}
      <div className="absolute inset-0 z-30 flex flex-col justify-end px-6 md:px-16 pb-24 md:pb-36">
        {/* Label */}
        <div className="hero-label flex items-center gap-3 mb-6">
          <span className="w-7 h-px" style={{ background: 'rgba(255,255,255,0.6)' }} />
          <span
            style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: '11px',
              letterSpacing: '3px',
              color: '#FFFFFF',
              textTransform: 'uppercase',
            }}
          >
            @ALLYWRK
          </span>
        </div>

        {/* Main headline */}
        <h1
          className="hero-h1 text-white"
          style={{
            fontFamily: 'Bebas Neue, sans-serif',
            fontSize: 'clamp(2.5rem, 7vw, 6.5rem)',
            lineHeight: 0.88,
            letterSpacing: '2px',
            marginBottom: '24px',
          }}
        >
          <span className="block">THE WORK</span>
          <span className="block" style={{ color: '#FFFFFF' }}>DONE BEHIND THE SCENES.</span>
        </h1>

        {/* Tagline */}
        <p
          className="hero-sub max-w-md leading-relaxed"
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '16px',
            color: 'rgba(255,255,255,0.55)',
            marginBottom: '40px',
          }}
        >
          Built for individuals and businesses who want to grow.
        </p>

        {/* CTAs */}
        <div className="hero-ctas flex flex-col sm:flex-row items-start gap-4">
          <button
            className="btn-lime"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Book A Session
          </button>
          <button
            className="btn-outline"
            onClick={() => {
              const el = document.getElementById('work');
              if (el) el?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View Our Work
          </button>
        </div>
      </div>
      {/* Scroll indicator */}
      <div
        className="absolute bottom-8 right-8 z-30 flex flex-col items-center gap-2"
        style={{ opacity: 0.5 }}
      >
        <span
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '10px',
            letterSpacing: '3px',
            color: '#fff',
            writingMode: 'vertical-rl',
          }}
        >
          SCROLL
        </span>
        <div className="scroll-bounce" style={{ width: '1px', height: '40px', background: 'rgba(255,255,255,0.4)' }} />
      </div>
    </section>
  );
}
